import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';

/**
 * Track when page was viewed.
 */
export const viewPage = (name: string): Promise<void> => {
  return Segment.page(name);
};
